/* TEEZOCA — collapsible product description (read more / read less) */
(function () {
  var PARAS_VISIBLE = 2; // how many paragraphs to show before truncating

  function initDescription(desc) {
    if (!desc || desc.dataset.tzReadmoreInit === '1') return;

    // Collect the direct paragraph children that actually have text
    var allNodes = Array.prototype.slice.call(desc.children);
    var paras = allNodes.filter(function (el) {
      return el.tagName === 'P' && el.textContent.trim().length > 0;
    });

    // Not enough content to bother truncating
    if (paras.length <= PARAS_VISIBLE) return;

    desc.dataset.tzReadmoreInit = '1';

    // Hide every paragraph after the first PARAS_VISIBLE.
    // We hide ALL children that come after the last visible paragraph,
    // so empty spacer <p> tags between them are hidden too.
    var lastVisible = paras[PARAS_VISIBLE - 1];
    var hiding = false;
    var hidden = [];
    allNodes.forEach(function (el) {
      if (el === lastVisible) { hiding = true; return; }
      if (hiding) {
        el.classList.add('tz-desc-hidden');
        hidden.push(el);
      }
    });

    if (!hidden.length) return;

    // Build the toggle button
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tz-readmore-btn';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var expanded = desc.classList.toggle('tz-desc-expanded');
      hidden.forEach(function (el) {
        el.classList.toggle('tz-desc-hidden', !expanded);
      });
      btn.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    desc.appendChild(btn);
  }

  function run() {
    document.querySelectorAll('.product__description').forEach(initDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
